import React from "react";
import Image from "next/image";

const MobBridgeEligibilty: React.FC = () => {
  return (
    <>
      <div
        id="CPA Eligibility Requirement"
        className="w-full py-8 relative bg-center bg-[#061A2F] bg-repeat bg-cover bg-[length:100% 100%] rounded-b-xl"
      >
        {/* Mobile View */}
        <div className="lg:hidden flex flex-col items-center px-4">
          <div className="text-center">
            <h2 className="text-xl mb-3 leading-6 text-[#FFF] font-semibold">
              <span className="inline-block border-b-2 border-[#ca7216]">
                CPA Eligibility Requirements
              </span>
            </h2>
          </div>

          {/* Credits Section */}
          <div className="flex flex-row gap-4 mt-4">
            <div className="investment bg-[#FFA548] px-6 py-3 rounded-md text-center">
              <p className="text-[16px] text-[#FFF]">CPA exam</p>
              <p className="text-[16px] text-[#FFF] font-semibold">
                120 Credits
              </p>
            </div>
            <div className="investment bg-[#FFA548] px-6 py-3 rounded-md text-center">
              <p className="text-[16px] text-[#FFF]">CPA license</p>
              <p className="text-[16px] text-[#FFF] font-semibold">
                150 Credits
              </p>
            </div>
          </div>
          <div className="border border-[#FFA548] bg-white text-center rounded-lg px-6 py-2 shadow-md mt-6">
            <p className="text-black font-medium text-[14px]">
              <span className="font-bold">
                Understanding U.S. semester hour credits:
              </span>
              <br /> Every year of university education is equivalent
              <br /> to 30 U.S. semester hour credits
            </p>
          </div>

          {/* Eligibility Info */}
          <div className="bg-[#FFA548] mt-6 py-3 px-4">
            <p className="text-[12px] text-black font-semibold text-center">
              The CPA exam eligibility requirement is a 4-year
              <br /> Bachelor's Degree (120 U.S. semester hour credits)
            </p>
          </div>

          {/* Divider Text */}
          <div className="flex justify-center py-4 w-full text-white">
            <p className="text-[20px] font-semibold">BUT</p>
          </div>

          {/* Bridge Program Info */}
          <div className="bg-[#071B31]/100 rounded-xl border-2 border-[#0C3D6F] py-4 px-10 flex flex-col gap-4 items-center">
            <Image
              src="/cpa/bridge-course/iconTri.png"
              alt="icon"
              className=""
              width={90.001}
              height={52.277}
              priority
            />
            <div className="text-center">
              <p className="text-white text-[16px] font-medium">
                Under the Pre-Education
                <br /> Eligibility option, you can now
                <br /> appear for the CPA exam with
                <br /> a 3-year B.Com/BBA (120 U.S.
                <br /> semester hour credits)
              </p>
              <p className="text-white text-[12px] leading-5 mt-6">
                *If you submit proof of enrolment into Miles'
                <br /> Approved Bridge Program.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MobBridgeEligibilty;
